import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Divider } from "antd";
import { isNil, isEmpty } from 'lodash';
import { ReactComponent as EdgelIcon } from "../../../../../assets/icons/edge.svg";
import reject_icon from "../../../../../assets/icons/reject_icon.png";
import return_icon from "../../../../../assets/icons/return_icon.png";
import cross_icon from "../../../../../assets/icons/cross_icon.png";
import check_icon from "../../../../../assets/icons/check_icon.png";

const Graph = () => {
  const apptrackDetails = useSelector(state => state.appTrack.apptrackDetails);
  // console.log("apptrackDetails:",apptrackDetails);

  return (
    <>
      <Row gutter={32} className="diagram-container">
        <Col span={24} style={{paddingBottom:"5.4rem"}}>
          <Divider className="top" />
        </Col>

        <Col span={24} className="main-flow-nodes">
          <div style={{display:"inline-grid"}}>
            <div
              className={
                (apptrackDetails?.activeTaskName === "task.name.application_submission" &&
                  isNil(apptrackDetails?.variablesIndexed?.submissionDate) 

                  ? "active-completion-node "
                  : "") + "state-node first"
              }
            >
              <span>Υποβολή Αίτησης</span>
            </div>
            <div className='reject-nodes'>
              <div className="return-dashed-edge-2"></div>
              <div className="return-triangle-2"></div>
              <div
                className={
                  (apptrackDetails?.activeTaskName === "task.name.cancel"
                    ? "active-reject-node "
                    : "") + "reject-node"
                }
              >
                <img style={{marginLeft:"5px"}} src={reject_icon}></img>
                <span>Ακύρωση Αίτησης</span>
              </div>
            </div>
          </div>

          <EdgelIcon className="edge-svg" />

          <div style={{display:"inline-grid"}}>
            <div
              className={
                (apptrackDetails?.activeTaskName === "task.name.application_evaluation" || 
                apptrackDetails?.activeTaskName === "task.name.application_evaluation_by_auditor" ||
                apptrackDetails?.activeTaskName === "task.name.accepted" ||
                apptrackDetails?.activeTaskName === "task.name.temporary_rejected" ||
                apptrackDetails?.activeTaskName === "task.name.final_rejected" ||
                apptrackDetails?.activeTaskName === "task.name.application_evaluation_by_committee"
                  ? "active-completion-node "
                  : "") + "state-node second"
              }
            >
              <span>Αξιολόγηση Αίτησης</span>
            </div>
            <div className='return-nodes'>
              <div className="return-dashed-edge"></div>
              <div className="return-triangle"></div>
              <div
                // className='return-node'
                className={
                  (apptrackDetails?.activeTaskName === "task.name.application_rejected" ||
                    (apptrackDetails?.activeTaskName === "task.name.application_submission" 
                      && 
                      !isNil(apptrackDetails?.variablesIndexed?.submissionDate)
                    ) 
                    ? "active-return-node "
                    : "") + "return-node"
                }
              >
                <img style={{marginLeft:"5px"}} src={return_icon}></img>
                <span>Επιστροφή στον Ωφελούμενο</span>
              </div>
            </div>
          </div>

          <EdgelIcon className="edge-svg" />

            <div
              className={
                (apptrackDetails?.activeTaskName === "task.name.issuance_of_provisional_classification"
                  ? "active-completion-node "
                  : "") + "state-node third"
              }
            >
              <span>΄Εκδοση προσωρινής Κατάταξης</span>
            </div>

          <EdgelIcon className="edge-svg" />

          <div style={{display:"inline-grid"}}>
            <div
              className={
                (apptrackDetails?.activeTaskName === "task.name.objection_submission"
                  ? "active-completion-node "
                  : "") + "state-node fourth"
              }
            >
              <span>Υποβολή Ένστασης</span>
            </div>
            <div className='reject-nodes-2'>
              <div
                className={
                  (apptrackDetails?.activeTaskName === "task.name.application_rejection"
                    ? "active-reject-node "
                    : "") + "reject-node-2"
                }
              >
                <img style={{marginLeft:"5px"}} src={reject_icon}></img>
                <span>Απένταξη Αίτησης</span>
              </div>
              <div className="return-dashed-edge-3"></div>
              <div className="return-triangle-3"></div>
            </div>
          </div>


          <EdgelIcon className="edge-svg" />

          <div
            className={
              (apptrackDetails?.activeTaskName === "task.name.final_classification"
                ? "active-completion-node "
                : "") + "state-node fifth"
            }
          >
            <span>΄Εκδοση τελικής Κατάταξης</span>
          </div>
        </Col>
      </Row>

      <Row gutter={32}>
        <Col span={24} style={{ height: 56 }}></Col>
      </Row>
    </>
  );
};

export default Graph;